/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var EnvironmentType;
(function (EnvironmentType) {
    EnvironmentType["SIRIUS"] = "SIRIUS";
    EnvironmentType["TENANT"] = "TENANT";
})(EnvironmentType || (EnvironmentType = {}));
export var SiriusEnvironment;
(function (SiriusEnvironment) {
    SiriusEnvironment["LOCAL"] = "LOCAL";
    SiriusEnvironment["SNAPSHOT"] = "SNAPSHOT";
    SiriusEnvironment["SELF_HOSTED"] = "SELF_HOSTED";
    SiriusEnvironment["DEV"] = "DEV";
    SiriusEnvironment["STAGING"] = "STAGING";
    SiriusEnvironment["INTEGRATION"] = "INTEGRATION";
    SiriusEnvironment["PRODUCTION"] = "PRODUCTION";
})(SiriusEnvironment || (SiriusEnvironment = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVuYW50LWNvbnRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGVuYW50cy90ZW5hbnQtY29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQW9ISCxNQUFNLENBQU4sSUFBWSxlQUdYO0FBSEQsV0FBWSxlQUFlO0lBQ3ZCLG9DQUFpQixDQUFBO0lBQ2pCLG9DQUFpQixDQUFBO0FBQ3JCLENBQUMsRUFIVyxlQUFlLEtBQWYsZUFBZSxRQUcxQjtBQUVELE1BQU0sQ0FBTixJQUFZLGlCQVFYO0FBUkQsV0FBWSxpQkFBaUI7SUFDekIsb0NBQWUsQ0FBQTtJQUNmLDBDQUFxQixDQUFBO0lBQ3JCLGdEQUEyQixDQUFBO0lBQzNCLGdDQUFXLENBQUE7SUFDWCx3Q0FBbUIsQ0FBQTtJQUNuQixnREFBMkIsQ0FBQTtJQUMzQiw4Q0FBeUIsQ0FBQTtBQUM3QixDQUFDLEVBUlcsaUJBQWlCLEtBQWpCLGlCQUFpQixRQVE1QiJ9